import api from './api';

// Type for ticket booking request
export type BookTicketRequest = {
  eventId: number;
  numberOfTickets: number;
};

// Type for ticket booking response
export type BookTicketResponse = {
  ticketId: number;
  eventId: number;
  userId: number;
  numberOfTickets: number;
  totalPrice: number;
  bookingDate: string;
  status: string;
  createdAt: string;
  updatedAt: string;
};

// Book tickets for an event
export const bookTickets = async (bookingData: BookTicketRequest): Promise<BookTicketResponse> => {
  const response = await api.post<BookTicketResponse>('/tickets', bookingData);
  return response.data;
};

// Get user's ticket bookings
export const getUserBookings = async (): Promise<BookTicketResponse[]> => {
  const response = await api.get<BookTicketResponse[]>('/tickets');
  return response.data;
};

// Get user's upcoming tickets
export const getUpcomingTickets = async (): Promise<BookTicketResponse[]> => {
  const response = await api.get<BookTicketResponse[]>('/tickets?isActive=true&eventStatus=upcoming');
  return response.data;
};

// Get user's past tickets
export const getPastTickets = async (): Promise<BookTicketResponse[]> => {
  const response = await api.get<BookTicketResponse[]>('/tickets?isActive=true&eventStatus=past');
  return response.data;
};

// Get user's cancelled tickets
export const getCancelledTickets = async (): Promise<BookTicketResponse[]> => {
  const response = await api.get<BookTicketResponse[]>('/tickets?isActive=false');
  return response.data;
};

// Get tickets for a specific event (for future use)
export const getEventTickets = async (eventId: number): Promise<BookTicketResponse[]> => {
  const response = await api.get<BookTicketResponse[]>(`/tickets/event/${eventId}`);
  return response.data;
};

// Cancel a ticket booking (for future use)
export const cancelTicket = async (ticketId: number): Promise<void> => {
  await api.delete(`/tickets/${ticketId}`);
};

// Cancel an upcoming ticket by setting isActive to false
export const cancelUpcomingTicket = async (ticketId: number): Promise<void> => {
  await api.put(`/tickets/${ticketId}`, { isActive: false });
};

// Get tickets sold count for a specific event
export const getTicketsSold = async (eventId: number): Promise<number> => {
  const response = await api.get<number>(`/all-events/${eventId}/tickets-sold`);
  return response.data;
};

// Download CSV of ticket purchasers for a specific event
export const downloadTicketPurchasers = async (eventId: number): Promise<Blob> => {
  const response = await api.get(`/events/${eventId}/download-ticket-purchasers`, {
    responseType: 'blob'
  });
  return response.data;
};
